import styled from "@emotion/styled";

export const Text = styled.p`
  margin-block-end: 20px;
`;
